var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTrickyleaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000063629515523768696900000003387386238669038745_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.8356,
    y1: 613.1626,
    x2: 921.288,
    y2: 396.6205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008849"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2024,
    style: {
      stopColor: "#2AA944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4491,
    style: {
      stopColor: "#57B43E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6858,
    style: {
      stopColor: "#7CBC39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8775,
    style: {
      stopColor: "#92C136"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9AC335"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M856.05,765.04c-31.58,41.49-91.62,121.31-146.19,130.98c-41.03,7.27-66.98-40.72-95.42-66.73 c-68.89-63.02-148.85-98.19-220.9-152.74c-75.77-57.37-72.34-156.8-54.59-241.57c0,0,39.04-69.41,94.14-134.72 C463.92,263.72,565.75,137,565.75,137s106.52,98.26,170.48,167.49C1001.85,591.99,856.06,765.03,856.05,765.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062900588977337788040000006512232355300681626_",
    gradientUnits: "userSpaceOnUse",
    x1: 10488.6162,
    y1: 2833.1516,
    x2: 10994.4756,
    y2: 2648.0161,
    gradientTransform: "matrix(-1 0 0 -1 11232.4287 3481.5994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008849"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2024,
    style: {
      stopColor: "#2AA944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#57B43E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5609,
    style: {
      stopColor: "#7CBC39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7031,
    style: {
      stopColor: "#92C136"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#9AC335"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062900588977337788040000006512232355300681626_)"
    },
    d: "M346.86,421.1 c11.64,227.78,365.6,485.04,505.01,349.16c-72.6,98.74-148.64,195.03-222.6,292.74c0.03-0.03-163.76-154.85-208.84-212.18 c-50.96-64.8-97.01-140.58-112.15-222.34C294.08,551.8,309.78,487.03,346.86,421.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTrickyleaf);
export default __webpack_public_path__ + "static/media/Logo_Trickyleaf.d02fa52c1b035d35661d17e94ff6a14a.svg";
export { ForwardRef as ReactComponent };